export { };

declare global {
  interface Array<T> {
    sum(selector: (item: T) => number): number;
  }
}

if (!Array.prototype.sum) {
  Array.prototype.sum = function <T>(this: T[], selector: (item: T) => number): number {
    return this.reduce((acc, item) => acc + (selector(item) || 0), 0);
  };
}